import {
	ReadFieldDefinitionRequest,
	FieldDefinitionServiceClient,
} from '../proto/admpb/fielddefinition_grpc_web_pb';
import { auth } from '../lib/auth/Auth';

const service = new FieldDefinitionServiceClient(
	window.env.GRPC_ENDPOINT,
	{},
	{ ...auth }
);

export async function readFieldDefinition(pageComponent) {
	return new Promise((resolve, reject) => {
		const req = new ReadFieldDefinitionRequest();
		console.log(pageComponent);
		req.setPageComponent(pageComponent);

		service.readFieldDefinition(req, {}, (error, response) => {
			if (error) {
				resolve({ userGuide: { pageComponent: '' } });
			} else {
				resolve(response.toObject());
			}
		});
	});
}
